import Swiper from "swiper11";
import { ImportBundle, lazyLoad, fixedsHeader, globalSearch, initSearch, initFancyBox, handleSendInquiry } from "./common";
import { Autoplay, Navigation, Pagination } from "swiper11/modules";

initFunction();

function initFunction() {
  lazyLoad();
  initEvent();
  initSwiper();
  globalSearch();
  initSearch();
  initFancyBox();
  handleSendInquiry({ formId: "#footer-1-form", trigger: "#footer-1-submit" });
  ImportBundle({ type: "css", onlyIndex: true }, [
    "https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css",
  ]);
}

function initSwiper() {
  new Swiper(".index-19 .index-19-banner .swiper-box .swiper", {
    modules: [Autoplay, Pagination, Navigation],
    loop: true,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 850,
    pagination: {
      el: ".index-19 .index-19-banner .swiper-box .custom-swiper-pagination",
      clickable: true,
    },
    navigation: {
      prevEl: ".index-19 .index-19-banner .swiper-box .prev",
      nextEl: ".index-19 .index-19-banner .swiper-box .next",
    },
  });

  new Swiper(".index-19 .index-19-video .swiper-box .swiper", {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 650,
    navigation: {
      prevEl: ".index-19 .index-19-video .swiper-box .prev",
      nextEl: ".index-19 .index-19-video .swiper-box .next",
    },
    pagination: {
      el: ".index-19 .index-19-video .swiper-box .custom-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1025: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      620: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
  });

  new Swiper(".index-19 .index-19-companie .swiper-box .swiper", {
    modules: [Autoplay, Pagination, Navigation],
    loop: true,
    slidesPerView: 1,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 650,
    pagination: {
      el: ".index-19 .index-19-companie .swiper-box .custom-swiper-pagination",
      clickable: true,
    },
    navigation: {
      prevEl: ".index-19 .index-19-companie .swiper-box .prev",
      nextEl: ".index-19 .index-19-companie .swiper-box .next",
    },
    breakpoints: {
      620: {
        slidesPerView: 6,
        spaceBetween: 25,
      },
      320: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
  });
}

function initEvent() {
  fixedsHeader("header-19", "header-fixeds_1 header__fixeds", 300);
}
